module.exports = __webpack_public_path__ + "img/bgImg.30cdd858.png";